import React, { useContext, useState } from "react";
import styles from "./Stats.module.scss";
import { Context } from "../Store";

const Stats = () => {
  const [state] = useContext(Context);

  return (
      <div className={`${styles.statsContainer} stories-stats`}>
        <div className={styles.statsBox}>
          <span className={styles.number}>{state.games.length}</span>
          <span className={styles.title}>Games</span>
        </div>
        <div className={styles.statsBox}>
          <span className={styles.number}>{state.parsedPlayers.length}</span>
          <span className={styles.title}>Players</span>
        </div>
        <div className={styles.statsBox}>
          <span className={styles.number}>{state.actionReplays.length}</span>
          <span className={styles.title}>Replays</span>
        </div>
      </div>
  );
};

export default Stats;
